import { useEffect, useRef } from 'react';

interface Confetto {
  color: { front: string; back: string };
  dimensions: { x: number; y: number };
  position: { x: number; y: number };
  rotation: number;
  scale: { x: number; y: number };
  velocity: { x: number; y: number };
}
function CanvasSuccess() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas == null) return;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const confetti: Confetto[] = [];
    const confettiCount = 300;
    const gravity = 0.5;
    const terminalVelocity = 5;
    const drag = 0.075;
    const colors = [
      { front: 'red', back: 'darkred' },
      { front: 'green', back: 'darkgreen' },
      { front: 'blue', back: 'darkblue' },
      { front: 'yellow', back: 'darkyellow' },
      { front: 'orange', back: 'darkorange' },
      { front: 'pink', back: 'darkpink' },
      { front: 'purple', back: 'darkpurple' },
      { front: 'turquoise', back: 'darkturquoise' }
    ];
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    const randomRange = (min: number, max: number) =>
      Math.random() * (max - min) + min;

    const initConfetti = () => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < confettiCount; i++) {
        confetti.push({
          color:
            colors[
              Math.floor(randomRange(0, colors.length))
            ],
          dimensions: {
            x: randomRange(10, 20),
            y: randomRange(10, 30)
          },
          position: {
            x: randomRange(0, canvas.width),
            y: canvas.height - 1
          },
          rotation: randomRange(0, 2 * Math.PI),
          scale: {
            x: 1,
            y: 1
          },
          velocity: {
            x: randomRange(-25, 25),
            y: randomRange(0, -50)
          }
        });
      }
    };

    const render = () => {
      if (ctx === null) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      confetti.forEach((confetto, index) => {
        const width =
          confetto.dimensions.x * confetto.scale.x;
        const height =
          confetto.dimensions.y * confetto.scale.y;

        // Move canvas to position and rotate
        ctx.translate(
          confetto.position.x,
          confetto.position.y
        );
        ctx.rotate(confetto.rotation);

        // Apply forces to velocity
        // eslint-disable-next-line no-param-reassign
        confetto.velocity.x -= confetto.velocity.x * drag;
        // eslint-disable-next-line no-param-reassign
        confetto.velocity.y = Math.min(
          confetto.velocity.y + gravity,
          terminalVelocity
        );
        // eslint-disable-next-line no-param-reassign
        confetto.velocity.x +=
          Math.random() > 0.5
            ? Math.random()
            : -Math.random();

        // Set position
        // eslint-disable-next-line no-param-reassign
        confetto.position.x += confetto.velocity.x;
        // eslint-disable-next-line no-param-reassign
        confetto.position.y += confetto.velocity.y;

        // Delete confetti when out of frame
        if (confetto.position.y >= canvas.height)
          confetti.splice(index, 1);

        // Loop confetto x position
        if (confetto.position.x > canvas.width)
          // eslint-disable-next-line no-param-reassign
          confetto.position.x = 0;
        if (confetto.position.x < 0)
          // eslint-disable-next-line no-param-reassign
          confetto.position.x = canvas.width;

        // Spin confetto by scaling y
        // eslint-disable-next-line no-param-reassign
        confetto.scale.y = Math.cos(
          confetto.position.y * 0.1
        );
        ctx.fillStyle =
          confetto.scale.y > 0
            ? confetto.color.front
            : confetto.color.back;

        // Draw confetto
        ctx.fillRect(
          -width / 2,
          -height / 2,
          width,
          height
        );

        // Reset transform matrix
        ctx.setTransform(1, 0, 0, 1, 0, 0);
      });

      window.requestAnimationFrame(render);
    };
    window.addEventListener('resize', () => {
      resizeCanvas();
    });

    setTimeout(() => {
      initConfetti();
      render();
    }, 1000);
  }, []);
  return (
    <canvas
      ref={canvasRef}
      className="pointer-events-none fixed inset-0 z-50"
    />
  );
}

export default CanvasSuccess;
